import React from 'react';
import './styles.css';
import TermPagesWrapper from './TermPagesWrapper';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <TermPagesWrapper>
      <>
        <Helmet>
          <title>Scrappi | Privacy Policy</title>
        </Helmet>
        <embed
          src="https://docs.google.com/document/d/e/2PACX-1vSMIZ3CmzzcBBjEe6ssJCRPtZZgvjG1flppG0rFDEozisL97cp50cdQVI3VOhit3chnZ_VRiDg2CoRk/pub?embedded=true"
          title="Privacy Policy"
          className="policy_embed"
        ></embed>
      </>
    </TermPagesWrapper>
  );
};

export default PrivacyPolicy;
